import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { socket } from "../socket/socket";
import {
  registerCallHandlers,
  unregisterCallHandlers,
} from "../socket/socketHandlers/callHandlers";
import { store } from "../app/store";

export const SocketProvider = ({ children }) => {
  const dispatch = useDispatch();

  const { accessToken, isAuthenticated, loading } = useSelector(
    (state) => state.auth
  );

  useEffect(() => {
    if (loading) return;

    // 🔴 User logged out
    if (!isAuthenticated || !accessToken) {
      socket.disconnect();
      return;
    }

    // ✅ Attach token before connect
    socket.auth = {
      token: accessToken,
    };

    socket.connect();
    console.log("🔌 Socket connected");

    // ✅ Register socket → redux handlers
    registerCallHandlers(socket, dispatch, store.getState);

    socket.on("connect_error", (err) => {
      console.error("❌ Socket error:", err.message);
    });

    return () => {
      unregisterCallHandlers(socket);
      socket.off("connect_error");
      socket.disconnect();
    };
  }, [accessToken, isAuthenticated, loading, dispatch]);

  return children;
};